import React, { Component } from "react";
import { states } from "../../States/States";
import styles from "../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import stylesRole from "../DatiSanitari/DatiSanitari.module.css";
import Calendar from "../../../../components/calendar/Calendar";
import OggettiUtili from "../../../../utils/OggettiUtili.json";
import Input from "../../../../components/textbox/Input";
import Autocomplete from "../../../../components/autocomplete/Autocomplete";
import Utils from "../../../../utils/Utils";
import RadioButton from "../../../../components/radiobutton/RadioButton";
import SegnalazioniService from "../../../../services/SegnalazioniServices";
import toasterConfig from "../../../../config/toasterConfig";
import { withTranslation } from "react-i18next";
import history from "../../../../utils/History";
import ToasterSingleton from "../../../../singleton/ToasterSingleton";
import ButtonRow from "../../../../components/ButtonRow/ButtonRow";
import SessioneUtente from "../../../../sessionManager/SessioneUtente";
import SelectAutocomplete from "../../../../components/selectAutocomplete/SelectAutocomplete";
import Ruoli from "../../../../utils/Ruoli";
import $ from "jquery";
import CheckBox from "../../../../components/checkbox/CheckBox";

class DatiSanitari extends Component {
    state = {
        datiSanitari: {
            asintomatico: "",
            dataInizioSintomi: "",
            comuneInizioSintomi: "",
            luogoInizioSintomiEstero: "",
            ricovero: "",
            struttura: "",
            strutturaExtra: "",
            reparto: "",
            motivo: "",
            dataRicovero: "",
            dataDimissione: "",
            dataDiagnosi: "",
            note: "",
        },
        comuni: JSON.parse(sessionStorage.getItem("comuni")),
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        struttureAndStabilimenti: JSON.parse(
            sessionStorage.getItem("struttureAndStabilimenti")
        ),
        struttureAndStabilimentiPerCodice: JSON.parse(
            sessionStorage.getItem("struttureAndStabilimentiPerCodice")
        ),
        reparti: JSON.parse(sessionStorage.getItem("reparti")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        nazioniPerCodice: JSON.parse(
            sessionStorage.getItem("nazioniPerCodice")
        ),
        repartiPerCodice: JSON.parse(
            sessionStorage.getItem("repartiPerCodice")
        ),
        malattieFocolaiPerCodice: JSON.parse(
            sessionStorage.getItem("malattieFocolaiPerCodice")
        ),
        malattiePremal: JSON.parse(sessionStorage.getItem("malattiePremal")),
        malattieConSchedaSpeciale: OggettiUtili.malattieConSchedaSpeciale,
        disabledModificaCampi: false,
    };

    constructor(props) {
        super(props);
        this._validate = this._validate.bind(this);
        this._back = this._back.bind(this);
        this.riceviValore = this.riceviValore.bind(this);
        this.setRicovero = this.setRicovero.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.controlloDatiToaster = this.controlloDatiToaster.bind(this);
        this.controlloModificaCampi = this.controlloModificaCampi.bind(this);
    }

    componentDidMount() {
        ToasterSingleton.instance().sottoscrizione(this);

        if (this.props.segnalazioneCopia.datiSanitari) {
            let datiSanitari = this.state.datiSanitari;
            datiSanitari.asintomatico = this.props.segnalazioneCopia
                .datiSanitari.asintomatico
                ? this.props.segnalazioneCopia.datiSanitari.asintomatico
                : "";
            datiSanitari.dataInizioSintomi = Utils.formatDateISO(
                this.props.segnalazioneCopia.datiSanitari.dataInizioSintomi,
                "/"
            );
            datiSanitari.comuneInizioSintomi = this.props.segnalazioneCopia
                .datiSanitari.comuneInizioSintomi
                ? this.state.comuniPerCodice[
                      this.props.segnalazioneCopia.datiSanitari
                          .comuneInizioSintomi
                  ]
                : "";
            datiSanitari.luogoInizioSintomiEstero = this.props.segnalazioneCopia
                .datiSanitari.luogoInizioSintomiEstero
                ? this.state.nazioniPerCodice[
                      this.props.segnalazioneCopia.datiSanitari
                          .luogoInizioSintomiEstero
                  ]
                : "";
            datiSanitari.ricovero = this.props.segnalazioneCopia.datiSanitari
                .ricovero
                ? this.props.segnalazioneCopia.datiSanitari.ricovero
                : "";
            datiSanitari.struttura = this.props.segnalazioneCopia.datiSanitari
                .struttura
                ? this.state.struttureAndStabilimentiPerCodice[
                      this.props.segnalazioneCopia.datiSanitari.struttura
                  ]
                : "";
            datiSanitari.strutturaExtra = ///per ora si appoggia su strutture, ma ci serve anche il dataset per strutture extra
                this.props.segnalazioneCopia.datiSanitari.strutturaExtra
                    ? this.state.struttureAndStabilimentiPerCodice[
                          this.props.segnalazioneCopia.datiSanitari
                              .strutturaExtra
                      ]
                    : "";
            datiSanitari.reparto = this.props.segnalazioneCopia.datiSanitari
                .reparto
                ? this.state.repartiPerCodice[
                      this.props.segnalazioneCopia.datiSanitari.reparto
                  ].codice
                : "";
            datiSanitari.motivo = this.props.segnalazioneCopia.datiSanitari
                .motivo
                ? this.props.segnalazioneCopia.datiSanitari.motivo
                : "";
            datiSanitari.dataRicovero = this.props.segnalazioneCopia
                .datiSanitari.dataRicovero
                ? Utils.formatDateISO(
                      this.props.segnalazioneCopia.datiSanitari.dataRicovero,
                      "/"
                  )
                : "";
            datiSanitari.dataDimissione = this.props.segnalazioneCopia
                .datiSanitari.dataDimissione
                ? Utils.formatDateISO(
                      this.props.segnalazioneCopia.datiSanitari.dataDimissione,
                      "/"
                  )
                : "";
            datiSanitari.dataDiagnosi = this.props.segnalazioneCopia
                .datiSanitari.dataDiagnosi
                ? Utils.formatDateISO(
                      this.props.segnalazioneCopia.datiSanitari.dataDiagnosi,
                      "/"
                  )
                : "";
            datiSanitari.note = this.props.segnalazioneCopia.datiSanitari.note
                ? this.props.segnalazioneCopia.datiSanitari.note
                : "";

            this.setState({ datiSanitari: datiSanitari });
        }
        this.controlloModificaCampi();
        this.disabledDate();
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione();
        ToasterSingleton.instance().pulisci();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disabledSelectAutocomplete();
        this.disabledDate();
    }

    controlloModificaCampi() {
        let disabledModificaCampi = Utils.controlloModificaCampi(
            this.props.segnalazione
        );
        if (disabledModificaCampi) {
            this.setState({ disabledModificaCampi: disabledModificaCampi });
        }
    }

    disabledSelectAutocomplete() {
        let condizione =
            (this.props.segnalazione && this.props.segnalazione.migrazione) ||
            SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Laboratorio.descrizione ||
            (this.props.segnalazioneDatiSpecificiCopia &&
                (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione ===
                    OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneDatiSpecificiCopia
                        .statoValidazione ===
                        OggettiUtili.statoValidazioneByLabel.Validata.codice));
        Utils.disabledSelectAutocomplete(condizione);
    }

    disabledDate() {
        if (
            (this.state.disabledModificaCampi ||
                this.state.datiSanitari.asintomatico === "true") &&
            this.props.malattia === "0664"
        ) {
            $(document).ready(function () {
                $("#dataInizioSintomi1").datepicker("disable");
            });
        } else {
            $(document).ready(function () {
                $("#dataInizioSintomi1").datepicker("enable");
            });
        }

        if (this.state.disabledModificaCampi) {
            $(document).ready(function () {
                $("#dataDimissione").datepicker("disable");
                $("#dataRicovero").datepicker("disable");
            });
        } else {
            $(document).ready(function () {
                $("#dataRicovero").datepicker("enable");
                $("#dataDimissione").datepicker("enable");
            });
        }
    }

    nextStep(segnalazione, segnalazioneCopia) {
        let path = "/wizardSegnalazione";
        history.push({
            pathname: path,
            state: {
                currentState: states.INFO_CLINICHE,
                segnalazione: segnalazione,
                segnalazioneCopia: segnalazioneCopia,
                datiCompletiECorretti: Utils.getCompletezzaStep(segnalazione),
            },
        });
    }

    callConfermaDatiSanitari() {
        let jsonInsertPulito = {
            datiSanitari: this.props.segnalazione.datiSanitari,
        };
        if (this.state.malattiePremal["giornaliero"].includes(this.props.datiPaziente.malattia) || this.state.malattiePremal["settimanale"].includes(this.props.datiPaziente.malattia)) {
            jsonInsertPulito["idoneitaPremal"] = Utils.retrieveIdoneitaPremal(
                this.props.segnalazione,
                this.props.datiPaziente,
                this.props.datiMedico
            );
        }

        console.log(jsonInsertPulito);
        this.props.showSpinner(true);
        SegnalazioniService.postConfermaDatiSanitari(
            this.props.segnalazione.idSegnalazione,
            jsonInsertPulito
        )
            .then((data) => {
                this.props.showSpinner(false);
                let segnalazioneSalvata = this.props.segnalazione;
                if (jsonInsertPulito["idoneitaPremal"]) {
                    segnalazioneSalvata["idoneitaPremal"] = jsonInsertPulito["idoneitaPremal"];
                }
                segnalazioneSalvata["stepConfermati"] =
                    data.data.stepConfermati;
                this.nextStep(segnalazioneSalvata, segnalazioneSalvata);
            })
            .catch(() => {
                this.props.showSpinner(false);
                console.log("[ERROR] conferma dati sanitari segnalazione");
            });
    }

    callPutSegnalazione() {
        let jsonInsert = this.props.segnalazione;
        if (this.props.segnalazioneCopia) {
            jsonInsert["infoCliniche"] =
                this.props.segnalazioneCopia.infoCliniche;
            jsonInsert["infoEpidemiologiche"] =
                this.props.segnalazioneCopia.infoEpidemiologiche;
            jsonInsert["infoLaboratorio"] =
                this.props.segnalazioneCopia.infoLaboratorio;
            jsonInsert["esito"] = this.props.segnalazioneCopia.esito;
            jsonInsert["datiSpecifici"] =
                this.props.segnalazioneCopia.datiSpecifici;
            if (this.state.malattiePremal["giornaliero"].includes(this.props.datiPaziente.malattia) || this.state.malattiePremal["settimanale"].includes(this.props.datiPaziente.malattia)) {
                jsonInsert["idoneitaPremal"] = Utils.retrieveIdoneitaPremal(
                    this.props.segnalazioneCopia,
                    this.props.datiPaziente,
                    this.props.datiMedico
                );
            }
        }
        let jsonInsertPulito = Utils.removeEmptyValueFromObject(jsonInsert);
        SegnalazioniService.putModificaSegnalazione(
            jsonInsertPulito,
            this.props.segnalazione.idSegnalazione,
            this.props.updateWizardState,
            this.props.segnalazione,
            this.props.showSpinner
        );
    }

    _validate(clickSalvaOConferma) {
        let { t } = this.props;
        if (
            this.state.datiSanitari.asintomatico !== "true" &&
            this.state.datiSanitari.dataInizioSintomi !== "" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.datiSanitari.dataInizioSintomi
                ),
                "-"
            )
        ) {
            let newMessaggio = Utils.replaceContentString(
                t("Messages.ERR_01_01_0C_0A"),
                "<nome campo>",
                t("DatiSanitari.dataIniziosintomi")
            );
            return this.aggiungiToaster(newMessaggio);
        } else if (
            this.state.datiSanitari.dataRicovero !== "" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.datiSanitari.dataRicovero
                ),
                "-"
            )
        ) {
            let newMessaggio = Utils.replaceContentString(
                t("Messages.ERR_01_01_0C_0A"),
                "<nome campo>",
                t("DatiSanitari.dataRicovero")
            );
            return this.aggiungiToaster(newMessaggio);
        } else if (
            this.state.datiSanitari.dataDimissione !== "" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.datiSanitari.dataDimissione
                ),
                "-"
            )
        ) {
            let newMessaggio = Utils.replaceContentString(
                t("Messages.ERR_01_01_0C_0A"),
                "<nome campo>",
                t("DatiSanitari.dataDimissione")
            );
            return this.aggiungiToaster(newMessaggio);
        } else if (
            this.state.datiSanitari.dataDiagnosi !== "" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.datiSanitari.dataDiagnosi
                ),
                "-"
            )
        ) {
            let newMessaggio = Utils.replaceContentString(
                t("Messages.ERR_01_01_0C_0A"),
                "<nome campo>",
                t("DatiSanitari.dataDiagnosi")
            );
            return this.aggiungiToaster(newMessaggio);
        } else if (
            Utils.checkDateIntervalMinore(
                this.props.segnalazione.dataSegnalazione,
                this.state.datiSanitari.dataInizioSintomi
            )
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0Z"]);
        }

        let validateDataInizioSintomi = Utils.checkDateInterval(
            this.state.datiSanitari.dataInizioSintomi,
            "31/12/1899"
        );
        let checkTodayDataInizioSintomi = Utils.checkDateLowerToday(
            this.state.datiSanitari.dataInizioSintomi
        );
        let validateDataRicovero = false;
        let checkTodayDataRicovero = false;
        if (this.state.datiSanitari.dataRicovero !== "") {
            validateDataRicovero = Utils.checkDateInterval(
                this.state.datiSanitari.dataRicovero,
                "31/12/1899"
            );
            checkTodayDataRicovero = Utils.checkDateLowerToday(
                this.state.datiSanitari.dataRicovero
            );
        }
        let validateDataDimissione = false;
        let checkTodayDataDimissione = false;
        if (this.state.datiSanitari.dataDimissione !== "") {
            validateDataDimissione = Utils.checkDateInterval(
                this.state.datiSanitari.dataDimissione,
                "31/12/1899"
            );
            checkTodayDataDimissione = Utils.checkDateLowerToday(
                this.state.datiSanitari.dataDimissione
            );
        }

        let checkDimissioneLowerRicovero = false;
        if (
            this.state.datiSanitari.dataDimissione !== "" &&
            this.state.datiSanitari.dataRicovero !== ""
        ) {
            checkDimissioneLowerRicovero = !Utils.checkDateInterval(
                this.state.datiSanitari.dataRicovero,
                this.state.datiSanitari.dataDimissione
            );
        }

        let validateDataDiagnosi = false;
        let checkTodayDataDiagnosi = false;
        if (this.state.datiSanitari.dataDiagnosi !== "") {
            validateDataDiagnosi = Utils.checkDateInterval(
                this.state.datiSanitari.dataDiagnosi,
                "31/12/1899"
            );
            checkTodayDataDiagnosi = Utils.checkDateLowerToday(
                this.state.datiSanitari.dataDiagnosi
            );
        }

        let checkDifferenzaMesi = 0;
        if (
            this.state.datiSanitari.dataInizioSintomi !== "" &&
            this.props.segnalazioneCopia.dataSegnalazione !== ""
        ) {
            checkDifferenzaMesi = Utils.getMonthsBetween(
                new Date(
                    Utils.transformDateForBackend(
                        this.state.datiSanitari.dataInizioSintomi
                    )
                ),
                new Date(
                    Utils.transformDateForBackend(
                        this.props.segnalazioneCopia.dataSegnalazione
                    )
                ),
                false
            );
            //checkDimissioneLowerRicovero = Utils.checkDateInterval(this.state.datiSanitari.dataRicovero, this.state.datiSanitari.dataDimissione);
        }

        if (validateDataInizioSintomi) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0C"]);
        } else if (checkTodayDataInizioSintomi) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0D"]);
        } else if (checkDifferenzaMesi >= 8) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0E"]);
        } else if (
            this.state.datiSanitari.comuneInizioSintomi.codice &&
            this.state.datiSanitari.luogoInizioSintomiEstero.codice
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0F"]);
        } else if (
            this.state.datiSanitari.ricovero === "0" &&
            this.state.datiSanitari.struttura
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0G"]);
        } else if (
            this.state.datiSanitari.ricovero === "0" &&
            this.state.datiSanitari.strutturaExtra
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0H"]);
        } else if (
            this.state.datiSanitari.struttura &&
            this.state.datiSanitari.strutturaExtra
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0I"]);
        } else if (
            this.state.datiSanitari.ricovero === "0" &&
            this.state.datiSanitari.reparto
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0L"]);
        } else if (
            this.state.datiSanitari.ricovero === "0" &&
            this.state.datiSanitari.motivo
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0M"]);
        } else if (
            this.state.datiSanitari.ricovero === "0" &&
            this.state.datiSanitari.dataRicovero
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0N"]);
        } else if (
            this.state.datiSanitari.ricovero === "0" &&
            this.state.datiSanitari.dataDimissione
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0O"]);
        } else if (validateDataRicovero) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0P"]);
        } else if (checkTodayDataRicovero) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0Q"]);
        } else if (validateDataDimissione) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0R"]);
        } else if (checkTodayDataDimissione) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0S"]);
        } else if (checkDimissioneLowerRicovero) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0T"]);
        } else if (validateDataDiagnosi) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0U"]);
        } else if (checkTodayDataDiagnosi) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0C_0V"]);
        }

        let ObjectForBackEnd = {};
        ObjectForBackEnd["dataInizioSintomi"] = Utils.transformDateForBackend(
            this.state.datiSanitari.dataInizioSintomi
        );
        ObjectForBackEnd["asintomatico"] = this.state.datiSanitari.asintomatico;
        ObjectForBackEnd["ricovero"] = this.state.datiSanitari.ricovero;
        ObjectForBackEnd["comuneInizioSintomi"] =
            this.state.datiSanitari.comuneInizioSintomi.codice;
        ObjectForBackEnd["luogoInizioSintomiEstero"] =
            this.state.datiSanitari.luogoInizioSintomiEstero.codice;
        ObjectForBackEnd["struttura"] =
            this.state.datiSanitari.struttura.codice;
        ObjectForBackEnd["strutturaExtra"] =
            this.state.datiSanitari.strutturaExtra.codice;
        ObjectForBackEnd["reparto"] = this.state.datiSanitari.reparto;
        ObjectForBackEnd["motivo"] = this.state.datiSanitari.motivo;
        ObjectForBackEnd["dataRicovero"] = Utils.transformDateForBackend(
            this.state.datiSanitari.dataRicovero
        );
        ObjectForBackEnd["dataDimissione"] = Utils.transformDateForBackend(
            this.state.datiSanitari.dataDimissione
        );
        ObjectForBackEnd["dataDiagnosi"] = Utils.transformDateForBackend(
            this.state.datiSanitari.dataDiagnosi
        );
        ObjectForBackEnd["note"] = this.state.datiSanitari.note;
        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        this.props.segnalazione["datiSanitari"] = res;

        if (clickSalvaOConferma === 1) {
            this.callPutSegnalazione();
        } else {
            this.callConfermaDatiSanitari();
        }
    }

    _back() {
        let path = "/ricercaSegnalazioni";
        history.push({ pathname: path });
    }

    setRicovero(value) {
        let stateDati = this.state.datiSanitari;

        if (value === "1" || value === "0") {
            stateDati.ricovero = value;
            this.setState({ datiSanitari: stateDati });
        }
    }

    riceviValore(field, event) {
        let newDatiSanitari = this.state.datiSanitari;
        if (field.currentTarget) {
            if (field.currentTarget.id === "dataInizioSintomi1") {
                newDatiSanitari.dataInizioSintomi = field.currentTarget.value;
            } else if (field.currentTarget.id === "dataDimissione") {
                newDatiSanitari.dataDimissione = field.currentTarget.value;
            } else if (field.currentTarget.id === "dataRicovero") {
                newDatiSanitari.dataRicovero = field.currentTarget.value;
            } else if (field.currentTarget.id === "dataDiagnosi") {
                newDatiSanitari.dataDiagnosi = field.currentTarget.value;
            }
        } else {
            if (field === "note") {
                newDatiSanitari.note = event.target.value;
            } else if (field === "motivo") {
                newDatiSanitari.motivo = event.target.value;
            } else if (field === "struttura") {
                newDatiSanitari.struttura = event.target.value;
            } else if (field === "strutturaExtra") {
                newDatiSanitari.strutturaExtra = event.target.value;
            } else if (field === "reparto") {
                newDatiSanitari.reparto = event.target.value;
            } else if (field === "comuneInizioSintomi") {
                newDatiSanitari.comuneInizioSintomi = event.target.value;
            } else if (field === "luogoInizioSintomiEstero") {
                newDatiSanitari.luogoInizioSintomiEstero = event.target.value;
            } else if (field === "asintomatico") {
                newDatiSanitari.asintomatico = event.target.value;
                if (newDatiSanitari.asintomatico === "true") {
                    newDatiSanitari.comuneInizioSintomi = "";
                    newDatiSanitari.luogoInizioSintomiEstero = "";
                    newDatiSanitari.dataInizioSintomi = "";
                }
            }
        }
        this.setState({
            datiSanitari: newDatiSanitari,
        });
    }

    controlloDatiToaster(tipo) {
        let textList = [];
        if (
            this.state.datiSanitari.asintomatico !== "true" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.datiSanitari.dataInizioSintomi
                ),
                "-"
            )
        )
            textList.push('Campo "Data Inizio Sintomi" mancante');
        if (!this.state.datiSanitari.ricovero)
            textList.push('Campo "Ricovero Ospedaliero" mancante');
        if (
            this.state.datiSanitari.dataDimissione !== "" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.datiSanitari.dataDimissione
                ),
                "-"
            )
        )
            textList.push('Campo "Data dimissione" errato');
        if (
            this.state.datiSanitari.dataRicovero !== "" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.datiSanitari.dataRicovero
                ),
                "-"
            )
        )
            textList.push('Campo "Data ricovero" errato');
        if (
            this.state.datiSanitari.dataDiagnosi !== "" &&
            Utils.isDateInValid(
                Utils.transformDateForBackend(
                    this.state.datiSanitari.dataDiagnosi
                ),
                "-"
            )
        )
            textList.push('Campo "Data diagnosi" errato');
        if (
            this.state.datiSanitari.ricovero === "1" &&
            !this.state.datiSanitari.struttura &&
            !this.state.datiSanitari.strutturaExtra
        )
            textList.push(
                'Campo "Struttura di Ricovero" o "Struttura di Ricovero extra ULSS" mancante'
            );
        if (this.state.datiSanitari.note.startsWith(" "))
            textList.push('Campo "Note" mancante');
        if (this.state.datiSanitari.motivo.startsWith(" "))
            textList.push('Campo "Motivo ricovero" mancante');

        if (textList.length > 0 && tipo === "1")
            return this.aggiungiToaster(textList, true);
        else if (
            textList.length > 0 &&
            tipo === "2" &&
            this.props.segnalazioneCopia.datiSanitari &&
            this.props.segnalazioneCopia.stepConfermati &&
            this.props.segnalazioneCopia.stepConfermati.datiSanitariConfermati
        ) {
            return this.aggiungiToaster(textList, true);
        } else {
            if (tipo === "1") {
                if (
                    (this.props.segnalazione &&
                        this.props.segnalazione.migrazione) ||
                    SessioneUtente.getInstance().ruoliUtente ===
                        Ruoli.Operatore_Laboratorio.descrizione ||
                    (this.props.segnalazioneCopia &&
                        (this.props.segnalazioneCopia.statoSegnalazione ===
                            OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                .codice ||
                            this.props.segnalazioneCopia.statoValidazione ===
                                OggettiUtili.statoValidazioneByLabel.Validata
                                    .codice))
                ) {
                    this.nextStep(
                        this.props.segnalazioneCopia,
                        this.props.segnalazioneCopia
                    );
                } else {
                    this._validate(0);
                }
            } else if (tipo === "2") this._validate(1);
        }
    }

    onSubmit(e) {
        e.preventDefault();
    }

    aggiungiToaster(text, textList) {
        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now(),
            textList: textList,
        });
    }

    render() {
        const { t } = this.props;

        let resFiltraStrutture =
            this.props.segnalazioneCopia.ulssSegnalazione &&
            this.state.struttureAndStabilimenti
                ? Utils.filtraStruttureAndStabilimenti(
                      this.props.segnalazioneCopia.ulssSegnalazione,
                      this.state.struttureAndStabilimenti
                  )
                : null;

        const firstSecton = (
            <div>
                <h6>Attenzione - Per l'effettivo inserimento della segnalazione è necessario che le prime tre
                    sezioni vengano compilate</h6>
                <h6>{t("DatiSanitari.datiSanitari")}</h6>
                <hr className={stylesRole.hr} />
                <div className="container">
                    <div className="row">
                        <div
                            className="col-lg-3"
                            style={
                                this.props.segnalazioneCopia.malattia === "0664"
                                    ? { display: "flex", alignItems: "end" }
                                    : { display: "none" }
                            }
                        >
                            <CheckBox
                                id={"asintomatico"}
                                checked={
                                    this.state.datiSanitari.asintomatico ===
                                    "true"
                                }
                                text={t("DatiSanitari.asintomatico")}
                                onChange={this.riceviValore}
                                newCheckbox={true}
                                fontColor={"#1b7ea9"}
                                fontSize={"18px"}
                                disabledFlag={this.state.disabledModificaCampi}
                            />
                        </div>
                        <div
                            className={`col-lg-${
                                this.props.segnalazioneCopia.malattia === "0664"
                                    ? "3"
                                    : "4"
                            } ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}
                        >
                            <div id="dataInizioSintomi">
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.dataIniziosintomi")}
                                    {this.state.datiSanitari.asintomatico ===
                                    "true" ? (
                                        <></>
                                    ) : (
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    )}
                                </p>

                                <Calendar
                                    id={"dataInizioSintomi1"}
                                    field={"dataInizioSintomi"}
                                    value={
                                        this.state.datiSanitari
                                            .dataInizioSintomi
                                    }
                                    onChange={this.riceviValore}
                                    disabled={
                                        (this.state.datiSanitari
                                            .asintomatico === "true" &&
                                            this.props.segnalazioneCopia
                                                .malattia) ||
                                        this.state.disabledModificaCampi
                                    }
                                    errorMessage={
                                        this.state.datiSanitari
                                            .dataInizioSintomi &&
                                        Utils.isDateInValid(
                                            this.state.datiSanitari
                                                .dataInizioSintomi
                                        )
                                            ? "Data non valida"
                                            : ""
                                    }
                                    error={
                                        this.state.datiSanitari
                                            .dataInizioSintomi &&
                                        Utils.isDateInValid(
                                            Utils.transformDateForBackend(
                                                this.state.datiSanitari
                                                    .dataInizioSintomi
                                            ),
                                            "-"
                                        )
                                    }
                                ></Calendar>
                            </div>
                        </div>
                        <div
                            className={`col-lg-${
                                this.props.segnalazioneCopia.malattia === "0664"
                                    ? "3"
                                    : "4"
                            } ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}
                        >
                            <div className={styles.fieldContainer}>
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.comuneIniziosintomi")}
                                </p>
                                <div id="comuneInizioSintomi">
                                    <Autocomplete
                                        id={"idComuneInizioSintomi"}
                                        value={
                                            this.state.datiSanitari
                                                .comuneInizioSintomi
                                        }
                                        keyField={"codice"}
                                        descriptionField={"descrizione"}
                                        disabled={
                                            this.state.datiSanitari
                                                .asintomatico === "true" &&
                                            this.props.segnalazioneCopia
                                                .malattia
                                        }
                                        suggestionField={"descrizione"}
                                        onChange={this.riceviValore}
                                        field={"comuneInizioSintomi"}
                                        placeholder={t(
                                            "DatiSegnalazioneAnagrafici.Comune_di_segnalazione"
                                        )}
                                        suggestions={this.state.comuni}
                                    ></Autocomplete>
                                </div>
                            </div>
                        </div>
                        <div
                            className={`col-lg-${
                                this.props.segnalazioneCopia.malattia === "0664"
                                    ? "3"
                                    : "4"
                            } ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}
                        >
                            <div className={styles.fieldContainer}>
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.luogoInizioSintomi")}
                                </p>
                                <div id="luogoInizioSintomiEstero">
                                    <Autocomplete
                                        id={"luogoInizioSintomiEstero"}
                                        value={
                                            this.state.datiSanitari
                                                .luogoInizioSintomiEstero
                                        }
                                        keyField={"codice"}
                                        descriptionField={"descrizione"}
                                        suggestionField={"descrizione"}
                                        disabled={
                                            this.state.datiSanitari
                                                .asintomatico === "true" &&
                                            this.props.segnalazioneCopia
                                                .malattia
                                        }
                                        onChange={this.riceviValore}
                                        field={"luogoInizioSintomiEstero"}
                                        placeholder={t(
                                            "DatiSegnalazioneAnagrafici.statoEstero"
                                        )}
                                        suggestions={this.state.nazioni}
                                    ></Autocomplete>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "0.5rem" }}>
                        <div className="col-lg-3">
                            <p className={stylesRole.testo}>
                                {t("DatiSanitari.ricoveroOspedaliero")}
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                            <div className="row">
                                <RadioButton
                                    id={"ricoveroSi"}
                                    name={"ricovero"}
                                    label={"Si"}
                                    value={"1"}
                                    onClick={this.setRicovero}
                                    checked={
                                        this.state.datiSanitari.ricovero === "1"
                                    }
                                />
                                <RadioButton
                                    id={"ricoveroNo"}
                                    name={"ricovero"}
                                    label={"No"}
                                    value={"0"}
                                    onClick={this.setRicovero}
                                    checked={
                                        this.state.datiSanitari.ricovero === "0"
                                    }
                                />
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div
                                className={styles.fieldContainer}
                                id="struttura"
                            >
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.strutturaRicovero")}
                                    {this.state.datiSanitari.ricovero === "1" &&
                                    (!this.state.datiSanitari.strutturaExtra ||
                                        this.state.datiSanitari.struttura) ? (
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </p>
                                <Autocomplete
                                    id={"struttura"}
                                    value={this.state.datiSanitari.struttura}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"struttura"}
                                    placeholder={t(
                                        "DatiSanitari.strutturaRicovero"
                                    )}
                                    suggestions={
                                        resFiltraStrutture &&
                                        resFiltraStrutture.struttureAndStabilimentiFiltrati
                                            ? resFiltraStrutture.struttureAndStabilimentiFiltrati
                                            : []
                                    }
                                ></Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div
                                className={styles.fieldContainer}
                                id="strutturaExtra"
                            >
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.strutturaRicoveroExAsl")}{" "}
                                    {this.state.datiSanitari.ricovero === "1" &&
                                    (!this.state.datiSanitari.struttura ||
                                        this.state.datiSanitari
                                            .strutturaExtra) ? (
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </p>
                                <Autocomplete
                                    id={"strutturaExtra"}
                                    value={
                                        this.state.datiSanitari.strutturaExtra
                                    }
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"strutturaExtra"}
                                    placeholder={t(
                                        "DatiSanitari.strutturaRicoveroExAsl"
                                    )}
                                    suggestions={
                                        resFiltraStrutture &&
                                        resFiltraStrutture.struttureAndStabilimentiRestanti
                                            ? resFiltraStrutture.struttureAndStabilimentiRestanti
                                            : []
                                    }
                                ></Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div className={styles.fieldContainer} id="reparto">
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.reparto")}{" "}
                                </p>
                                <SelectAutocomplete
                                    id={"reparto"}
                                    field={"reparto"}
                                    newSelect={true}
                                    onChange={this.riceviValore}
                                    disabled={
                                        (this.props.segnalazione &&
                                            this.props.segnalazione
                                                .migrazione) ||
                                        SessioneUtente.getInstance()
                                            .ruoliUtente ===
                                            Ruoli.Operatore_Laboratorio
                                                .descrizione ||
                                        this.props.segnalazioneCopia
                                            .statoSegnalazione ===
                                            OggettiUtili
                                                .statoSegnalazioneByLabel
                                                .Archiviato.codice ||
                                        this.props.segnalazioneCopia
                                            .statoValidazione ===
                                            OggettiUtili.statoValidazioneByLabel
                                                .Validata.codice
                                    }
                                    value={this.state.datiSanitari.reparto}
                                    functionMap={Utils.mapToArray(
                                        this.state.reparti
                                    ).map((oggetto) => {
                                        return (
                                            <option value={oggetto.codice}>
                                                {oggetto.descrizione}
                                            </option>
                                        );
                                    })}
                                ></SelectAutocomplete>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "0.5rem" }}>
                        <div className="col-lg-12">
                            <div id="motivo">
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.motivoRicovero")}
                                </p>
                                <Input
                                    type={"textarea"}
                                    placeholder="campo a testo libero"
                                    //style={{ minWidth: "279px", minHeight: "150px" }}
                                    value={this.state.datiSanitari.motivo}
                                    id="motivo"
                                    field={"motivo"}
                                    onChange={this.riceviValore}
                                    onValidate={
                                        this.state.datiSanitari.motivo.startsWith(
                                            " "
                                        )
                                            ? 1
                                            : 2
                                    } /// onValidate: 1 errore,  altro valore ok
                                    errorMessage={"Campo motivo non valido"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "0.5rem" }}>
                        <div className={`col-lg-4 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div id="dataRicoveroDiv">
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.dataRicovero")}
                                </p>
                                <Calendar
                                    id={"dataRicovero"}
                                    value={this.state.datiSanitari.dataRicovero}
                                    field={"dataRicovero"}
                                    disabled={this.state.disabledModificaCampi}
                                    onChange={this.riceviValore}
                                    errorMessage={
                                        this.state.datiSanitari.dataRicovero &&
                                        Utils.isDateInValid(
                                            this.state.datiSanitari.dataRicovero
                                        )
                                            ? "Data non valida"
                                            : ""
                                    }
                                    error={
                                        Utils.isDateInValid(
                                            Utils.transformDateForBackend(
                                                this.state.datiSanitari
                                                    .dataRicovero
                                            ),
                                            "-"
                                        ) &&
                                        this.state.datiSanitari.dataRicovero !==
                                            ""
                                    }
                                ></Calendar>
                            </div>
                        </div>
                        <div className={`col-lg-4 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div id="dataDimissioneDiv">
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.dataDimissione")}
                                </p>
                                <Calendar
                                    id={"dataDimissione"}
                                    value={
                                        this.state.datiSanitari.dataDimissione
                                    }
                                    field={"dataDimissione"}
                                    onChange={this.riceviValore}
                                    disabled={this.state.disabledModificaCampi}
                                    errorMessage={
                                        this.state.datiSanitari
                                            .dataDimissione &&
                                        Utils.isDateInValid(
                                            this.state.datiSanitari
                                                .dataDimissione
                                        )
                                            ? "Data non valida"
                                            : ""
                                    }
                                    error={
                                        Utils.isDateInValid(
                                            Utils.transformDateForBackend(
                                                this.state.datiSanitari
                                                    .dataDimissione
                                            ),
                                            "-"
                                        ) &&
                                        this.state.datiSanitari
                                            .dataDimissione !== ""
                                    }
                                ></Calendar>
                            </div>
                        </div>
                        <div className={`col-lg-4 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div id="dataDiagnosi">
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.dataDiagnosi")}
                                </p>
                                <Calendar
                                    id={"dataDiagnosi"}
                                    value={this.state.datiSanitari.dataDiagnosi}
                                    field={"dataDiagnosi"}
                                    onChange={this.riceviValore}
                                    errorMessage={
                                        this.state.datiSanitari.dataRicovero &&
                                        Utils.isDateInValid(
                                            this.state.datiSanitari.dataDiagnosi
                                        )
                                            ? "Data non valida"
                                            : ""
                                    }
                                    error={
                                        Utils.isDateInValid(
                                            Utils.transformDateForBackend(
                                                this.state.datiSanitari
                                                    .dataDiagnosi
                                            ),
                                            "-"
                                        ) &&
                                        this.state.datiSanitari.dataDiagnosi !==
                                            ""
                                    }
                                ></Calendar>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "0.5rem" }}>
                        <div className="col-lg-12">
                            <div id="note">
                                <p className={stylesRole.testo}>
                                    {t("DatiSanitari.note")}
                                </p>
                                <Input
                                    placeholder="campo a testo libero"
                                    type={"textarea"}
                                    id={"note"}
                                    value={this.state.datiSanitari.note}
                                    field={"note"}
                                    onChange={this.riceviValore}
                                    onValidate={
                                        this.state.datiSanitari.note.startsWith(
                                            " "
                                        )
                                            ? 1
                                            : 2
                                    } /// onValidate: 1 errore,  altro valore ok
                                    errorMessage={"Campo note non valido"}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" style={{ marginTop: "2rem" }}>
                    <div className="col-lg-12">
                        <div className={styles.mandatoryColor}>
                            *Campo obbligatorio
                        </div>
                    </div>
                </div>
            </div>
        );

        const buttonRow = (
            <ButtonRow
                onClickConfermaEProsegui={() => this.controlloDatiToaster("1")}
                isArchiviato={
                    (this.props.segnalazione &&
                        this.props.segnalazione.migrazione) ||
                    SessioneUtente.getInstance().ruoliUtente ===
                        Ruoli.Operatore_Laboratorio.descrizione ||
                    (this.props.segnalazioneCopia &&
                        (this.props.segnalazioneCopia.statoSegnalazione ===
                            OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                .codice ||
                            this.props.segnalazioneCopia.statoValidazione ===
                                OggettiUtili.statoValidazioneByLabel.Validata
                                    .codice))
                }
                nextStep={true}
                modalTextConferma={"Buttons.confermaModifica"}
                onClickSalva={() => this.controlloDatiToaster("2")}
                back={this._back}
            />
        );

        return (
            <div
                className={
                    (this.props.segnalazione &&
                        this.props.segnalazione.migrazione) ||
                    SessioneUtente.getInstance().ruoliUtente ===
                        Ruoli.Operatore_Laboratorio.descrizione ||
                    this.props.segnalazioneCopia.statoSegnalazione ===
                        OggettiUtili.statoSegnalazioneByLabel.Archiviato
                            .codice ||
                    this.props.segnalazioneCopia.statoValidazione ===
                        OggettiUtili.statoValidazioneByLabel.Validata.codice
                        ? "visualizzazione"
                        : ""
                }
            >
                {ToasterSingleton.instance().renderToaster()}
                <form onSubmit={this.onSubmit}>
                    <fieldset
                        style={{ paddingTop: "1rem" }}
                        disabled={
                            (this.props.segnalazione &&
                                this.props.segnalazione.migrazione) ||
                            SessioneUtente.getInstance().ruoliUtente ===
                                Ruoli.Operatore_Laboratorio.descrizione ||
                            this.props.segnalazioneCopia.statoSegnalazione ===
                                OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                    .codice ||
                            this.props.segnalazioneCopia.statoValidazione ===
                                OggettiUtili.statoValidazioneByLabel.Validata
                                    .codice
                        }
                    >
                        {firstSecton}
                    </fieldset>
                    {buttonRow}
                </form>
            </div>
        );
    }
}

export default withTranslation("common")(DatiSanitari);
